<template>
    <div
      class="modal right fade trader-info"
      id="trader-info"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"       
    >
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase">TRADER CONCENTRATION</h5>
            <button type="button" class="close"  @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="table-responsive">
              <div v-if="loading" class="loader">
                <img src="@/assets/img/loader.svg" alt="" />
              </div>
              <table
                class="table align-items-center table-flush table-hover bidtbl"
              >
                <thead class="thead-light psticky">
                  <tr>
                    <th
                      scope="col"
                      class="sort"
                      v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'firstName'
                          ? 'sort-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'firstName'
                          ? 'sort-desc'
                          : '',
                      ]"
                      @click="sort('firstName')"
                    >
                      Trader
                    </th>
                    <th scope="col" class="text-center">Cusip Max Qty</th>
                    <th
                      scope="col"
                      class="sort"
                      v-bind:class="[
                        sortOrder == 'ASC' && sortColumn == 'autobidderCapital'
                          ? 'sort-asc'
                          : '',
                        sortOrder == 'DESC' && sortColumn == 'autobidderCapital'
                          ? 'sort-desc'
                          : '',
                      ]"
                      @click="sort('autobidderCapital')"
                    >
                    Capital Invested/Bought Today <br>IMS CAPITAL/AT RISK
                    </th>
                    <!-- <th scope="col" class="text-left">CUSIP CONC/DOLLAR AMOUNT/Bought Today/AT RISK</th> -->
                    <th scope="col" class="text-left">STATE/CONC/DOLLAR AMOUNT<br>Bought Today/IMS CAPITAL/AT RISK </th>
                    <th scope="col" class="text-left">RATING/CONC/DOLLAR AMOUNT <br> Bought Today/IMS CAPITAL/AT RISK </th>
                    <th scope="col" class="text-center">COMPLIANCE <br> STATUS</th>
                    <th scope="col" class="text-center">TRADING <br> STATUS</th>
                  </tr>
                </thead>
                <tbody class="list no-cursor">
                  <tr v-if="totalRows == 0 && !loading">
                    <td><p class="nodata">No data available</p></td>
                  </tr>
                  <tr v-for="trader in traders" :key="trader.id">
                    <td
                    >
                      {{ trader.firstName }} {{ trader.lastName }}
                    </td>
                    <td class="text-center" >
                     <span  v-if="trader.cusipConcList.length > 0">
                      {{ formatNumber(trader.cusipConcList[0].concentrationValue) }} 
                    </span> 
                    </td>
                    <td class="input-d text-left">
                      <span class="text-warning" v-if="trader.maxCapitalConcList.length > 0">
                      {{ trader.maxCapitalConcList[0].concentrationValueDolAmt  | currency }} / {{trader.maxCapitalConcList[0].capitalInvestedDolAmt  | currency}}  <br> {{ trader.maxCapitalConcList[0].invOfferDolAmt  | currency}} / {{trader.maxCapitalConcList[0].capitalAtRisk  | currency }}
                    </span> 
                    </td>
                    
                    <td class="text-left" >
                      <div class="listAcc" v-for="(state,index) in trader.stateConcList" :key="index" v-show="index < 3">
                        <span class="text-primary border-bottom py-2">
                          {{ state.concentration }} / {{ state.concentrationValue }}% / {{ state.concentrationValueDolAmt  | currency }} <br>
                         {{ state.capitalInvestedDolAmt  | currency }} /  {{ state.invOfferDolAmt  | currency}} /  {{ state.capitalAtRisk  | currency}}
                        </span>
                      </div>
                      <span  @click="toggleViewConcentrationModal(trader,'STATE')" class="dropdown-item moreAcc" v-show="trader.stateConcList.length > 3">
                          ({{trader.stateConcList.length - 3 }} More)
                      </span>
                    </td>
                    <td class="text-left" >
                      <div class="listAcc" v-for="(rating,index) in trader.creditRatingConcList" :key="index" v-show="index < 3">
                        <span class="text-success border-bottom py-2">{{ rating.concentrationList[0] }} <span style="font-size: 15px; color: rgb(0, 135, 212);">&rarr;</span> {{ rating.concentrationList[rating.concentrationList.length - 1] }} / {{ rating.concentrationValue }}% / {{ rating.concentrationValueDolAmt  | currency }} <br> {{ rating.capitalInvestedDolAmt  | currency }} /  {{ rating.invOfferDolAmt  | currency}} /  {{ rating.capitalAtRisk  | currency}}</span>
                      </div>
                      <span  @click="toggleViewConcentrationModal(trader,'RATING')" class="dropdown-item moreAcc" v-show="trader.creditRatingConcList.length > 3">
                          ({{trader.creditRatingConcList.length - 3 }} More)
                      </span>
                    </td>
                    <td class="text-center">
                       <span v-if="trader.complianceCheck == 'TRUE'" class="text-success">ENABLED</span>
                       <span v-if="trader.complianceCheck == 'FALSE'" class="text-danger">DISABLED</span>
                    </td>
                    <td class="text-center">
                       <span v-if="trader.autobidderActive == 'TRUE'" class="text-success">ENABLED</span>
                       <span v-if="trader.autobidderActive == 'FALSE'" class="text-danger">DISABLED</span>
                    </td>
                
                  </tr>
                </tbody>
              </table>
              <!-- Pagination-->
              <b-pagination
                class="mt-4"
                :total-rows="totalRows"
                v-model="currentPage"
                :per-page="perPage"
                @input="getTraderList(currentPage)"
              ></b-pagination>
              <div class="total-records">
                <span>Total Records : {{ totalRows }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Concentration 
        v-if="concentrationModalOpen"
        v-bind:traderData="selectedTrader"
        v-bind:selectedOrgToken="selectedOrgToken"
        @close="toggleConcentrationModal()"/>
      <ViewConcentration
        v-if="viewConcentrationModalOpen"
        v-bind:traderData="selectedTrader"
        v-bind:type="selectedConcentrationType"
        @close="toggleViewConcentrationModal()"/>    
    </div>
</template>

<script>
import config from "@/config";
import Concentration from "../branch/BranchSetConcentrationModal.vue"
import ViewConcentration from "../ConcentrationViewDataModal.vue"

export default {
      name: 'modal',
      components :{
        Concentration,
        ViewConcentration
      },
      props: ['selectedBranch'],
      data() {
          return {
            loading : false,
            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortColumn: "firstName",
            sortOrder: "ASC",
            traders: [],
            searchValue: "",
            concentrationModalOpen : false,
            selectedTrader: null,
            viewConcentrationModalOpen : false,
            selectedConcentrationType : ""

          };
      },
      methods: { 
        toggleViewConcentrationModal(data,type){
          this.selectedTrader = {...data}
          this.selectedConcentrationType = type
          this.viewConcentrationModalOpen = !this.viewConcentrationModalOpen;
        },
        sort(column) {
          this.sortColumn = column;
          this.sortOrder =
            this.sortOrder == "ASC"
              ? (this.sortOrder = "DESC")
              : (this.sortOrder = "ASC");
          this.getTraderList();
        },
        toggleConcentrationModal(data){
            this.selectedTrader = {...data}
            this.concentrationModalOpen = !this.concentrationModalOpen;
            if(!this.concentrationModalOpen){
                this.getTraderList()
            }
            },
        getTraderList() {
            this.loading = true;
            const auth = {
                headers: {
                    "org-token": this.selectedBranch.branchOrgToken
                },
            };
            this.$http
                .get(
                config.baseUrlAutoBidder +
                    "/autobidder/traders?page=" +
                    this.currentPage +
                    "&size=" +
                    this.perPage +
                    "&search=" +
                    this.searchValue +
                    "&status=ACTIVE" +
                    "&sortColumn=" +
                    this.sortColumn +
                    "&sortOrder=" +
                    this.sortOrder +
                    "&group=Trader"+
                    "&startOfDay="+
                    this.moment(this.moment().format("MM-DD-YYYY")).utc().format("YYYY-MM-DD HH:mm:ss"),
                auth
                )
                .then((result) => {
                this.totalRows = result.data.pageInfo.totalElements;
                this.traders = result.data.content;
                this.loading = false;
                })
                .catch((e) => {
                console.log(e);
                });
        },
       
      },
      created(){
        this.getTraderList()
      }
      
  };
  </script>
